/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_Tab_PausedInputs */

const en_settings_billing_tab_paused = /** @type {(inputs: Settings_Billing_Tab_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paused`)
};

const zh_settings_billing_tab_paused = /** @type {(inputs: Settings_Billing_Tab_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已暂停`)
};

/**
* | output |
* | --- |
* | "Paused" |
*
* @param {Settings_Billing_Tab_PausedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_billing_tab_paused = /** @type {((inputs?: Settings_Billing_Tab_PausedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_Tab_PausedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_billing_tab_paused(inputs)
	return zh_settings_billing_tab_paused(inputs)
});
export { settings_billing_tab_paused as "settings.billing.tab_paused" }